export function parseCellValue(value: any): string | boolean {
        if (typeof value === 'string') {
            const lower = value.toLowerCase();
            if (lower === 'true') {
                return true;
            } else if (lower === 'false') {
                return false;
            }
        }
        return value;
    }
